import { motion, useAnimation, useInView } from "framer-motion";
import React, { useEffect, useRef } from "react";

const FramerAnimate = ({ children }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const slideControls = useAnimation();
  useEffect(() => {
    if (isInView) {
      slideControls.start("visible");
    }
  }, [isInView]);
  return (
    <div ref={ref}>
      <motion.div
        variants={{
          hidden: { opacity: 0, x: -300 },
          visible: { opacity: 1, x: 0 },
        }}
        initial="hidden"
        animate={slideControls}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default FramerAnimate;
